'use client';

import ToastPopup from '@wconcept/wconcept-ui-renewal/src/components/molecules/ToastPopup';
import { getToastBottom } from '@utils/getToastBottom';
import { createContext, useCallback, useMemo, useState } from 'react';

interface IProps {
  children?: React.ReactNode;
}

const ToastContext = createContext<{
  openToast: (value: string, isIPhoneXApp?: boolean) => void;
  closeToast: () => void;
}>({
  openToast: () => {},
  closeToast: () => {},
});

function ToastProvider({ children }: IProps) {
  const [isActive, setIsActive] = useState(false);
  const [text, setText] = useState('');
  const [isIphoneApp, setIsIphoneApp] = useState(false);

  const openToast = useCallback((value: string, isIPhoneXApp?: boolean) => {
    setIsActive(true);
    setText(value);
    setIsIphoneApp(isIPhoneXApp || false);
    setTimeout(() => {
      setText('');
      setIsActive(false);
    }, 3000);
  }, []);

  const closeToast = useCallback(() => {
    setText('');
    setIsActive(false);
    setIsIphoneApp(false);
  }, []);

  const value = useMemo(
    () => ({
      openToast,
      closeToast,
    }),
    [closeToast, openToast]
  );

  return (
    <ToastContext.Provider value={value}>
      {isActive ? (
        <ToastPopup
          text={text}
          isIPhoneXApp={isIphoneApp}
          bottom={getToastBottom()}
        />
      ) : null}
      {children}
    </ToastContext.Provider>
  );
}

export { ToastProvider, ToastContext };
